<template lang="pug">
card-financeiro(
  :cardTitle="tituloCard"
  @execAction="$emit('click')",
  :showBtnAction="showButtonCadastrar"
  :btnType="typeActionButton"
  :btnIconClass="iconActionButton"
  :btnActionTitle="nameActionButton"
)
  template(slot="body")
    div
      app-divider-refresh-button(
        v-if="hasHeader || hasRefreshButton"
        :label="headerLabel",
        :hasButton="hasRefreshButton",
        :content="tooltipRefreshButton"
        :showBorder="false"
        @click="updateListagem",
      )
    el-row
      .divider(v-if="showBorder")
    el-table(:data="dataForTable")
      template(slot="empty", v-if="!dataForTable") Não há registros.
      template(slot="empty", v-else) Não há registros.
      slot(name="columns")
    .pagination(v-if="totalElements > 0")
      app-paginacao(
        :total="totalElements"
        :pagina="pagina",
        @changePage="alterarPagina",
        :tamanhoPagina="15"
      )
</template>

<script>
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import CONFIGS from '@/constants/configs'
import CardFinanceiro from '@/screens/financeiro/components/CardFinanceiro'
import AppPaginacao from '@/components/AppPaginacao'

export default {

  components: {
    AppDividerRefreshButton,
    CardFinanceiro,
    AppPaginacao
  },

  props: {
    /**
      * Titulo do card
      */
    tituloCard: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Se terá um action botão, que pode ser para cadastrar, ou qualquer outro fim
     */
    hasActionButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
      * Tipo do action button
      * @values primary, success, warning, danger, info, text
      */
    typeActionButton: {
      type: String,
      required: false,
      default: 'success'
    },
    /**
      * Icone que será exibido dentro do action button
      */
    iconActionButton: {
      type: String,
      required: false,
      default: 'fas fa-plus'
    },
    /**
      * Tamanho do action button
      * @values mini, small, medium, default
      */
    sizeActionButton: {
      type: String,
      required: false,
      default: 'small'
    },
    /**
      * Nome que será exibido dentro do action button
      */
    nameActionButton: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Se a lista terá um header
     */
    hasHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Se a lista terá um botão de refresh
     */
    hasRefreshButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * O nome do header da lista
     */
    headerLabel: {
      type: String,
      required: false,
      default: 'Listagem'
    },
    /**
     * Tooltip do botão de refresh
     */
    tooltipRefreshButton: {
      type: String,
      required: false,
      default: 'Atualizar'
    },
    /**
     * Se terá uma borda abaixo do header da lista
     */
    showBorder: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Um array com os dados que serão exibidos na lista
     */
    dataForTable: {
      type: Array,
      required: false
    },
    /**
     * Total de elementos da listagem, sem paginação, ou seja, o total absoluto
     */
    totalElements: {
      type: Number,
      reqquired: false,
      default: 0
    },
    /**
     * Página atual da listagem, sempre será atualizada ao mudar de página
     */
    pagina: {
      type: Number,
      required: true
    },

    showButtonCadastrar: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      CONFIGS
    }
  },

  methods: {
    /**
      * Aciona ao mudar de página
      *
      * @property {number} newPage a nova pagina que irá para o filtro da paginação
      */
    alterarPagina (newPage) {
      return this.$emit('changePage', newPage)
    },
    /**
      * Aciona ao clicar no botão de atualizar listagem
      *
      */
    updateListagem () {
      return this.$emit('updateListagem')
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

h1 {
  margin-top: 0px;
}

.divider {
  border: 1px solid $border-color;
  margin-bottom: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 1vh;
}

.btn-cadastrar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/AppListagem.vue